import React from 'react';

function TopHeaderLocalesDropDownTemplate({ title, icon, isLanguage = false }) {
  return (
    <div className={`locations-dropdown-template mobile ${isLanguage ? 'languages' : ''}`}>
      <img src={icon} alt="locations icon" />
      <p>{title}</p>
    </div>
  );
}

export default TopHeaderLocalesDropDownTemplate;
